export const getBearerString = () => {
  let accessToken = localStorage.getItem("accessToken");
  return `Bearer ${accessToken}`;
};
